import { Dispatch, SetStateAction, useContext, useMemo } from 'react';

import { useMutation } from '@apollo/client';
import { IContextMenuItem } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import s from 'pages/Clients/Clients.module.scss';
import { UserGroup } from 'pages/Clients/interfaces';
import {
  DELETE_USER_GROUP,
  DeleteUserGroupRequest,
  DeleteUserGroupResponse,
} from 'schemas';

export const useContextMenuItems = (
  setModalGroup: Dispatch<
    SetStateAction<UserGroup | Record<string, never> | null>
  >
): IContextMenuItem<UserGroup>[] => {
  const { t } = useContext(LocalizationContext);

  const [deleteUserGroup] = useMutation<
    DeleteUserGroupResponse,
    DeleteUserGroupRequest
  >(DELETE_USER_GROUP, {
    update: (cache, { data }) => {
      const deletedGroup = data?.deleteUserGroup;
      if (deletedGroup) {
        cache.modify({
          fields: {
            userGroups: (groups: UserGroup[], { readField }) =>
              groups.filter(
                (group) => readField('uuid', group) !== deletedGroup.uuid
              ),
          },
        });
      }
    },
  });

  return useMemo(
    () => [
      {
        key: 'edit',
        text: t('edit'),
        iconName: 'EditIcon',
        onClick: (group) => setModalGroup(group),
      },
      {
        key: 'delete',
        text: t('delete'),
        iconName: 'BucketIcon',
        className: s.remove,
        disabled: (group) => group.user_count > 0,
        onClick: ({ uuid }) => {
          deleteUserGroup({ variables: { uuid } });
        },
      },
    ],
    [setModalGroup, deleteUserGroup]
  );
};
